export const SCREEN_MAX_WIDTH = 1280;
export const HEADER_HEIGHT = 72;
export const SCENARIO_CARD_WIDTH = 300;

